<template>
  <div class="container">
    <div class="main">
      <div class="flex">
        <div class="tab" :class="{ active: num == 1 }" @click="num = 1">
          全部
        </div>
        <div class="tab" :class="{ active: num == 2 }" @click="num = 2">
          实物
        </div>
        <div class="tab" :class="{ active: num == 3 }" @click="num = 3">
          虚拟
        </div>
        <div class="tab" :class="{ active: num == 4 }" @click="num = 4">
          积分
        </div>
      </div>
      <div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多啦"
          :immediate-check="false"
          @load="load_more"
        >
          <div
            class="goods"
            v-for="(item, index) in list"
            :key="index"
            @click="
              $router.push({ name: 'jfrecorddetail', query: { id: item.id } })
            "
          >
            <img :src="item.cover" class="pic" alt="" />
            <div style="width: 100%">
              <p style="word-break: break-all">{{ item.title }}</p>
              <p style="font-size: 14px" v-if="item.type_front == 1">实物</p>
              <p style="font-size: 14px" v-else-if="item.type_front == 2">
                虚拟
              </p>
              <p style="font-size: 14px" v-else-if="item.type_front == 3">
                积分
              </p>
              <p style="margin-top: 10px; color: #dfbd91">
                {{ item.score }}积分
              </p>
            </div>
            <div
              style="
                white-space: nowrap;
                font-size: 14px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
              "
            >
              <!-- <p style="text-align: right">剩余{{ item.storage }}件</p> -->
              <div class="bt">查看详情</div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "jfrecord",
  data() {
    return {
      num: 1,
      list: [],
      loading: false,
      finished: false,
      page: 1,
      type: "",
    };
  },
  watch: {
    num: {
      handler: function (val) {
        if (val == 1) {
          this.type = "";
          this.list = [];
          this.page = 1;
          this.loading = false;
          this.finished = false;
          this.init();
        } else if (val == 2) {
          this.type = "1";
          this.list = [];
          this.page = 1;
          this.loading = false;
          this.finished = false;
          this.init();
        } else if (val == 3) {
          this.type = "2";
          this.list = [];
          this.page = 1;
          this.loading = false;
          this.finished = false;
          this.init();
        } else if (val == 4) {
          this.type = "3";
          this.list = [];
          this.page = 1;
          this.loading = false;
          this.finished = false;
          this.init();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.$toast.loading({
      duration: 0,
      forbidClick: true,
    });
    this.$axios({
      method: "post",
      url: "/api/score/orderlist",
    }).then((res) => {
      this.$toast.clear();
      this.list = res.data.data.list;
    });
  },
  methods: {
    init() {
      this.$axios({
        method: "post",
        url: "/api/score/orderlist",
        data: this.qs.stringify({
          type: this.type,
          page: this.page,
        }),
      }).then((res) => {
        this.$toast.clear();
        this.list = res.data.data.list;
      });
    },
    load_more() {
      this.page += 1;
      var that = this;
      setTimeout(function () {
        that
          .$axios({
            method: "post",
            url: "/api/score/orderlist",
            data: that.qs.stringify({
              page: that.page,
              type: that.type,
            }),
          })
          .then((res) => {
            console.log(res.data);
            if (res.data.code == 0) {
              that.list = that.list.concat(res.data.data.list);
            }
            that.loading = false;
            if (res.data.data.list.length == 0) {
              //数据全部加载完成
              that.finished = true;
            } else {
              that.finished = false;
            }
          });
      }, 500);
    },
  },
};
</script>
<style scoped>
.container {
  min-height: 100vh;
  background: #f5f5f5;
}
.flex {
  display: flex;
  justify-content: space-between;
}
.tab {
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: white;
  border: 1px solid rgba(187, 187, 187, 100);
  font-size: 14px;
  border-radius: 20px;
}
.active {
  color: #cab586;
  border: 1px solid rgba(202, 181, 134, 100);
}
.goods {
  display: flex;
  margin: 10px 0;
  background: white;
  padding: 10px;
}
.pic {
  width: 73px;
  height: 73px;
  object-fit: cover;
  border-radius: 15px;
  flex-shrink: 0;
  margin-right: 10px;
}
.bt {
  width: 80px;
  height: 30px;
  background: #cab586;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  color: white;
  margin-top: auto;
  white-space: nowrap;
}
.main {
  padding: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/jfrecord.vue